// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderLocation":"c-m_eT","advertDetailHeaderLocation__value":"c-m_eU"};